import { render, staticRenderFns } from "./EditorHeaderReportButton.vue?vue&type=template&id=01dc8a10&scoped=true&"
import script from "./EditorHeaderReportButton.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderReportButton.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderReportButton.vue?vue&type=style&index=0&id=01dc8a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc8a10",
  null
  
)

export default component.exports